// extracted by mini-css-extract-plugin
module.exports = {"filler":"FullScreenError_filler__2hal7","text":"FullScreenError_text__2IxZq"};